export default __webpack_public_path__ + "static/media/win.1ac59a37.wav";